export default __webpack_public_path__ + "assets/images/b900b6141a927e0060710459791302be.png";